import axios from 'axios'
import { serverErrorMessage } from './serverErrorMessage.js'

export function normalizeAxiosApiError(error, fallback) {
  const status = error.response?.status
  const serverMessage = serverErrorMessage(error.response?.data)

  return {
    message: serverMessage || error.message || fallback,
    code: status ? `http_${status}` : 'network_error',
    status,
    retryable: !status || status >= 500 || status === 429,
    cause: error,
  }
}

/** True only for a deliberate abort — a request timeout is ECONNABORTED, not this. */
export function isCancelledRequest(error) {
  return axios.isCancel(error) || error?.code === 'ERR_CANCELED'
}
